export const ACTIVITY_LABELS = {
    INVENTORY_UPLOAD: 'Inventory file upload',
    BANK_TRANSACTION_UPLOAD: 'Bank file upload',
    INVENTORY_DELETE: 'Inventory data delete',
    REMITTANCE_UPLOAD: 'Payments file upload',
    INVOICE_UPLOAD: 'Invoices file upload',
};
